import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import objectSupport from "dayjs/plugin/objectSupport";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(objectSupport);
dayjs.extend(localizedFormat);

const LOCALE =
  new Intl.DateTimeFormat().resolvedOptions().locale?.toLowerCase() ?? "en";
export let dayJsLocale = LOCALE;
import(`../../node_modules/dayjs/locale/${LOCALE}.js`)
  .then(() => {
    dayjs.locale(LOCALE);
  })
  .catch(e => {
    if (e.code === "MODULE_NOT_FOUND") {
      let simplifiedLocale: string;
      if (LOCALE.includes("-")) {
        simplifiedLocale = LOCALE.split("-")[0];
      } else if (LOCALE.includes("_")) {
        simplifiedLocale = LOCALE.split("_")[0];
      } else {
        console.warn(
          `Failed to dynamically load locale with error ${e} falling back to ${LOCALE}`
        );
        return;
      }
      dayJsLocale = simplifiedLocale;
      import(`../../node_modules/dayjs/locale/${simplifiedLocale}.js`)
        .then(() => {
          dayjs.locale(LOCALE);
        })
        .catch(e => {
          console.warn(
            `Failed to dynamically load locale with error ${e} falling back to ${LOCALE}`
          );
        });
    }
  });

export default dayjs;
